import decimalCurrencyToSmallestUnit from '@/utils/decimalCurrencyToSmallestUnit';

const getAffirmPrice = (
  discountedPrice: number,
  originalPrice: number,
): number => {
  const price = discountedPrice || originalPrice;

  return decimalCurrencyToSmallestUnit(price);
};

export default getAffirmPrice;
